import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { ZoneManagementContent } from './Components/ZoneManagementContent';
import { EventTriggerProvider } from 'src/EventRuleManagement/Providers/EventTriggerProvider';
import { NotificationStrategyProvider } from './Providers/NotificationStrategyProvider';

export const ZoneManagement = (): React.JSX.Element => (
  <Page title="Zones" accessKey={'zones'} isSearchable={true}>
    <EventTriggerProvider>
      <NotificationStrategyProvider>
        <ZoneManagementContent />
      </NotificationStrategyProvider>
    </EventTriggerProvider>
  </Page>
);
